export default __webpack_public_path__ + "media/images/tenant/chooseTabas/reason_1-175ffd0b869c7499977f6662aceff5bb.webp";